import type { QueryClient } from '@tanstack/react-query';

type Options = {
  /** マッチさせたいパス先頭のリスト（いずれかにマッチすれば対象） */
  include: readonly string[];
  /** マッチから除外したいパス先頭のリスト */
  exclude?: readonly string[];
};

/**
 * Orval 生成の queryKey（先頭が URL パス文字列）に対してパス先頭マッチで invalidate する。
 *
 * 例: invalidateByPathPrefix(qc, { include: ['/projects'], exclude: ['/projects/options'] })
 */
export const invalidateByPathPrefix = (queryClient: QueryClient, { include, exclude }: Options) => {
  queryClient.invalidateQueries({
    predicate: (query) => {
      const key = query.queryKey[0];
      if (typeof key !== 'string') return false;
      if (exclude?.some((p) => key === p || key.startsWith(`${p}/`))) return false;
      return include.some((p) => key === p || key.startsWith(`${p}/`));
    },
  });
};
